import { render } from "./transfer-status.vue?vue&type=template&id=92d2e880&scoped=true"
import script from "./transfer-status.vue?vue&type=script&lang=js"
export * from "./transfer-status.vue?vue&type=script&lang=js"

import "./transfer-status.vue?vue&type=style&index=0&id=92d2e880&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d2e880"]])

export default __exports__